// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"336c5e4197a6fa8a7370","691":"56d5bede27a8820c5145"}[chunkId] + ".js";
};